export default __webpack_public_path__ + "static/media/icon-edit.f1475621.svg";